import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
import { onWidthResize, offWidthResize } from '../utils/resize.js';
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class ContactIntro {
    constructor(element) {
        this.element = element;
        this.title = this.element.querySelector('.contact-intro__title');
        this.body = this.element.querySelector('.contact-intro__body');
        this.cards = this.element.querySelectorAll('.contact-intro__card');

        this.init();
    }

    init = () => {
        this.initTitleAnimation();
        this.initBodyAnimation();
        this.initCardAnimation();
    }

    initTitleAnimation = () => {
        if (!this.title) return;
        this.titleSplit = new SplitText(this.title, { type: 'lines,words', linesClass: 'lineParent' });
        gsap.fromTo(
            this.titleSplit.words,
            { yPercent: 100 },
            {
                yPercent: 0,
                duration: 0.8,
                delay: 0.7,
                stagger: { each: 0.08, ease: 'power2.out', from: 'start' },
                ease: 'power3.out',
                scrollTrigger: { trigger: this.element },
                onComplete: () => {
                    onWidthResize(this.onTitleResize);
                },
            }
        );
    }

    onTitleResize = () => {
        this.titleSplit?.revert();
        offWidthResize(this.onTitleResize);
    }

    initBodyAnimation = () => {
        if (!this.body) return;
        this.bodySplit = new SplitText(this.body, { type: 'lines,words', linesClass: 'lineParent' });
        gsap.fromTo(
            this.bodySplit.words,
            { yPercent: 100 },
            {
                yPercent: 0,
                duration: 0.6,
                delay: 0.9,
                stagger: { each: 0.02, ease: 'power2.out', from: 'start' },
                ease: 'power3.out',
                scrollTrigger: { trigger: this.element },
                onComplete: () => {
                    onWidthResize(this.onBodyResize);
                },
            }
        );
    }

    onBodyResize = () => {
        this.bodySplit?.revert();
        offWidthResize(this.onBodyResize);
    }

    initCardAnimation = () => {
        if (!this.cards.length) return;
        let master_delay = 1.2;
        gsap.set(this.cards, { clipPath: 'inset(0% 0% 100% 0%)' });

        this.cards.forEach((card, i) => {
            const pill = card.querySelector('.contact-intro__pill');
            const email = card.querySelector('.contact-intro__email');

            gsap.to(card, {
                clipPath: 'inset(0% 0% 0% 0%)',
                duration: 1,
                delay: i * 0.1 + master_delay,
                ease: 'power3.inOut',
                scrollTrigger: {
                    trigger: card,
                    start: 'top bottom',
                },
            });

            if (pill) {
                gsap.fromTo(
                    pill,
                    { opacity: 0 },
                    {
                        opacity: 1,
                        duration: 0.5,
                        delay: i * 0.1 + 0.6 + master_delay,
                        ease: 'power2.out',
                        scrollTrigger: { trigger: card, start: 'top bottom' },
                    }
                );
            }

            if (email) {
                gsap.fromTo(
                    email,
                    { opacity: 0 },
                    {
                        opacity: 1,
                        duration: 0.5,
                        delay: i * 0.1 + 0.8,
                        ease: 'power2.out',
                        scrollTrigger: { trigger: card, start: 'top bottom' },
                    }
                );
            }
        });
    }
}
